import 'magnific-popup/dist/jquery.magnific-popup.min.js';

$(function () {
  const signInUrl = $('.portal-popup').data('signin-url');
  $('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: true,
    alignTop: false,
    closeBtnInside: true,
    callbacks: {
      close: function () {
        window.location.replace(signInUrl);
      }
    }
  });
});